import { useEffect, useRef, useState } from "react";
import { resolveInitialPayerPhone } from "../utils/deliveryPhone";
import {
  formatCurrency,
  isFwMomoMethod,
  fwNetworkFor,
} from "../config/market";
import useMinimumOrderValue from "../hooks/useMinimumOrderValue";
import { linesSubtotal, meetsMinimumOrder } from "../utils/minimumOrder";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Grid, Table, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@mui/material/Container";
import momo from "../assets/img/momo.jpg";
import airtel from "../assets/img/airtel_money.png";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {
  Divider,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Image } from "react-bootstrap";
import styled from "styled-components";

import {
  createOrder,
  payAirtelMoneyCheckout,
  payMoMoCheckout,
  payCardCheckout,
  resetOrderCreation,
} from "../redux/createOrderAction.js";
import Navbar from "../components/Navbar";
import useDeliveryFee from "../redux/useDeliveryFee";
import DeliveryFeeStatus from "../components/DeliveryFeeStatus";
import FreightCheckoutNotice from "../components/FreightCheckoutNotice";
import { newIdempotencyKey } from "../utils/idempotency";
import CreditCardForm from "../components/CreditCardForm/CreditCardForm";
import { extractCreatedOrderId } from "../redux/checkout";
import { followCardRedirect } from "../utils/cardPayment";
import { apiSetContactEmail } from "../api/profileApi";
import {
  BUYER_TYPE_OPTIONS,
  BUYER_ID_TYPE_OPTIONS,
  BUYER_TYPE_CONSUMER,
  BUYER_ID_TIN,
  buyerIdHint,
  buildBuyerPayload,
  formatBuyerSummary,
} from "../utils/buyerIdentity";
import { toast } from "react-toastify";
import useCheckoutDeliverySchedule from "../hooks/useCheckoutDeliverySchedule";
import DeliveryTimePicker from "../components/DeliveryTimePicker";

const PayCardButton = styled.button`
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;
  margin-top: 10px;
  border-radius: 4px;
  &:disabled {
    background-color: #ccc;
    color: #aaa;
    font-weight: 300;
    font-size: 14px;
    cursor: not-allowed;
  }
`;
const AirtelPayButton = styled.button`
  border: none;
  padding: 7px 15px;
  background-color: #f00;
  color: white;
  cursor: pointer;
  margin-top: 10px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  display: flex;
  &:disabled {
    background-color: #ccc;
    color: #aaa;
    font-weight: 300;
    font-size: 14px;
    cursor: not-allowed;
  }
`;
// Optional email capture at checkout. Most Lusuku customers register by PHONE
// and have no email, so the receipt has nowhere to go. We ASK here, never
// require: no validation, and it never gates a pay button.
const EmailFieldWrap = styled.div`
  margin: 0 0 14px;
  max-width: 360px;
`;
const EmailLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  margin: 0 0 8px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;
const OptionalTag = styled.span`
  font-weight: 600;
  color: #9ca3af;
  text-transform: none;
  letter-spacing: 0;
  font-size: 11px;
  margin-left: 6px;
`;
const EmailInput = styled.input`
  width: 100%;
  padding: 13px 14px;
  border: 1.6px solid #e5e7eb;
  border-radius: 10px;
  font-size: 15px;
  &:focus {
    outline: none;
    border-color: #83b524;
  }
`;
const EmailHint = styled.div`
  margin-top: 8px;
  font-size: 12.5px;
  color: #6b7280;
`;
// Optional buyer tax identity at checkout. A business buyer who wants the order
// under their own tax id can add one; everyone else leaves it closed and stays
// a walk-in. Never required, and it never gates a pay button.
const BuyerWrap = styled.div`
  margin: 14px 0 4px;
  max-width: 420px;
`;
const BuyerToggle = styled.button`
  border: none;
  background: none;
  padding: 0;
  color: #00668b;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  &:hover {
    text-decoration: underline;
  }
`;
const BuyerPanel = styled.div`
  border: 1.4px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px;
  max-width: 420px;
`;
const BuyerRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
`;
const BuyerSelect = styled.select`
  flex: 1;
  padding: 12px 10px;
  border: 1.6px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  background: #fff;
  &:focus {
    outline: none;
    border-color: #83b524;
  }
`;
const BuyerSummary = styled.div`
  margin-top: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #14211f;
`;
const useStyles = makeStyles((theme) => ({
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
      paddingBottom: "5px",
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  inputGreen: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "green",
      },
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "green",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "green",
    },
    "& .MuiOutlinedInput-input": {
      color: "green",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "green",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "green",
    },
  },
  tableHeader: {
    backgroundColor: "#506266",
    color: "#ffffff",
    borderRadius: "8px",
  },
  tableHeaderCenter: {
    backgroundColor: "#506266",
    color: "#ffffff",
    borderRadius: "8px",
    textAlign: "center",
  },
  responsiveFont: {
    fontSize: 16,

    [theme.breakpoints.up("sm")]: {
      fontSize: 18,
    },

    [theme.breakpoints.up("md")]: {
      fontSize: 20,
    },

    [theme.breakpoints.up("lg")]: {
      fontSize: 24,
    },
  },
  responsiveImage: {
    width: "100%",
    // height: 'auto',

    [theme.breakpoints.up("md")]: {
      maxWidth: 600,
    },
  },
  responsiveCard: {
    width: "100%",
    // height: 'auto',
    justifyContent: "center",
    alignItems: "center",

    [theme.breakpoints.up("md")]: {
      maxWidth: 600,
    },
  },

  responsiveTable: {
    width: "100%",
    overflowX: "auto",

    "& table": {
      minWidth: 500,
      width: "100%",

      [theme.breakpoints.up("md")]: {
        minWidth: 700,
      },
    },
  },
}));

const validationSchema = Yup.object().shape({
  cardNumber: Yup.string().required("Card Number is required."),
  expiry_month: Yup.string().required("Expiry Month is required."),
  expiry_year: Yup.string().required("Expiry Year is required."),
  cardCvv: Yup.string().required("CVV is required."),
  cardType: Yup.string().required("Card Type is required."),
  fullName: Yup.string().required("Full Name is required."),
});

const PlaceOrderScreen = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const { shippingAddress, products, paymentMethod, total } = useSelector(
    (state) => state.cart
  );

  const user = useSelector((state) => state.user.currentUser);
  const [orderSource] = useState("Web");
  const { orderCreationStatus, paymentCreationStatus } = useSelector(
    (state) => state.orders
  );

  /* Second line of defence on the minimum order value. The cart says it first
     and the server is the gate that counts; this stops a deep link or a tab
     left open from the days before the floor existed posting a basket the
     server will only refuse after the customer has entered a phone number.
     Goods only, summed from the lines because `cart.total` drifts. */
  const minimumOrderValue = useMinimumOrderValue();
  const belowMinimumOrder = !meetsMinimumOrder(
    linesSubtotal(products),
    minimumOrderValue
  );

  // Server-authoritative delivery fee (distance-based, signed quote).
  const {
    fee: serverShippingFee,
    distanceKm,
    quoteToken,
    isReady: deliveryFeeReady,
    isFailed: deliveryFeeFailed,
    isBlocked: deliveryFeeBlocked,
    error: deliveryFeeError,
    refresh: refreshDeliveryFee,
    fulfillment: quoteFulfillment,
    freightConsentRequired,
  } = useDeliveryFee({
    vendorId: products?.[0]?.vendorId,
    customerLat: shippingAddress?.latLng?.lat,
    customerLng: shippingAddress?.latLng?.lng,
    items: products,
  });

  // Express or a scheduled window. The in-house basket has no seller hours, so
  // the server offers every window in its horizon.
  const deliveryTime = useCheckoutDeliverySchedule({ flow: "inhouse" });

  // One idempotency key per checkout attempt (Contract §B4): retries of THIS
  // order reuse it so the backend dedupes instead of double-creating.
  const idempotencyKeyRef = useRef(newIdempotencyKey());

  // Shared props for the fee/total cells: fee failure must be VISIBLE with a
  // Retry, never a permanent "Calculating…" (Contract §C3).
  const feeStatusProps = {
    isReady: deliveryFeeReady,
    isFailed: deliveryFeeFailed,
    isBlocked: deliveryFeeBlocked,
    error: deliveryFeeError,
    onRetry: refreshDeliveryFee,
  };

  // if there are no products, redirect to cart page
  useEffect(() => {
    if (
      Object.keys(shippingAddress).length === 0 ||
      Object.keys(paymentMethod).length === 0 ||
      Object.keys(products).length === 0
    ) {
      history.push("/cart");
    }
  }, [shippingAddress, paymentMethod, products, history]);

  const formik = useFormik({
    initialValues: {
      cardNumber: "",
      expiry_month: "",
      expiry_year: "",
      cardCvv: "",
      cardType: "",
      fullName: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // Handle your form submission here
      cardPlaceOrderHandler(values);
    },
  });

  const [postData, setPostData] = useState({
    mobile: "",
  });  
  // Payer prefill: most customers pay with the number we deliver to (or their
  // account number), so seed the mobile-money field once instead of forcing a
  // retype. Fully editable for "someone else is paying", and the once-guard
  // means we never fight a customer who clears the field on purpose.
  const payerPrefilledRef = useRef(false);
  useEffect(() => {
    if (payerPrefilledRef.current) return;
    const prefill = resolveInitialPayerPhone(shippingAddress, user);
    if (prefill) {
      payerPrefilledRef.current = true;
      setPostData((d) => (d.mobile ? d : { ...d, mobile: prefill }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippingAddress, user]);


  // Support both email auth shape (result._id) and phone/Google auth shape (flat _id)
  const userId = user?.result?._id || user?._id;
  const userName = user?.result?.name || user?.name;
  const userEmail = user?.result?.email || user?.email;
  // Optional email capture. Phone-only customers have no address on file, so we
  // ask at the one moment the reason is concrete (the receipt). Never required.
  const [emailInput, setEmailInput] = useState("");
  const needsEmail = !userEmail;
  // Optional buyer tax identity (B2B). Closed by default; opening it and typing
  // anything sends a `buyer` block, otherwise the order stays a walk-in.
  const [buyerOpen, setBuyerOpen] = useState(false);
  const [buyerType, setBuyerType] = useState(BUYER_TYPE_CONSUMER);
  const [buyerIdType, setBuyerIdType] = useState(BUYER_ID_TIN);
  const [buyerIdNumber, setBuyerIdNumber] = useState("");
  const [buyerName, setBuyerName] = useState("");
  useEffect(() => {
    if (!userId) {
      history.push("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Reset stale order status from previous sessions on mount
  useEffect(() => {
    dispatch(resetOrderCreation());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // Delivery fee is fetched by useDeliveryFee above (auto-refreshes on address change).
  // Display-only total — the server recomputes the charged total on order-create.
  const totalOrderCostPlusShipping = Number(total) + Number(serverShippingFee);

  useEffect(() => {
    // /momoOrderPage is the DIRECT-MTN status page (Uganda). On FW-momo
    // markets (ZM) the customer is redirected to Flutterwave's page instead —
    // navigating here would strand them on a poller that can never confirm.
    if (
      paymentMethod === "MOMO" &&
      !isFwMomoMethod("MOMO") &&
      orderCreationStatus === "fulfilled"
    ) {
      history.replace("/momoOrderPage");
    } else if (paymentMethod === "COD" && orderCreationStatus === "fulfilled") {
      history.replace("/orderPage");
    }
  }, [orderCreationStatus, paymentMethod, history]);

  const placeOrderHandler = (e) => {
    e.preventDefault();
    deliveryTime.submitOrder(createOrder, {
      orderItems: products?.map((item) => ({
        ...item,
        vendorId: item.vendorId,
      })),
      shippingAddress: shippingAddress,
      // Server recomputes the fee/total; quote token lets it honour the
      // displayed fee. No client-computed fee is sent as authoritative.
      clientQuoteToken: quoteToken,
      distanceKm,
      paymentMethod: paymentMethod,
      itemsPrice: total,
      totalPrice: totalOrderCostPlusShipping,
      customerName: userName,
      client_id: userId,
      orderSrc: orderSource,
      idempotencyKey: idempotencyKeyRef.current,
    });
  };

  // Shared create-order payload (server recomputes the fee/total; the quote
  // token lets it honour the displayed fee — Contract §B1/§B2).
  const buildCreateOrderPayload = () => {
    // Sent ONLY when the shopper captured a buyer; a walk-in omits it, which
    // is exactly how the server reads an absent buyer.
    const buyer = buildBuyerPayload({
      type: buyerType,
      idType: buyerIdType,
      idNumber: buyerIdNumber,
      name: buyerName,
    });
    return {
      orderItems: products,
      shippingAddress: shippingAddress,
      clientQuoteToken: quoteToken,
      distanceKm,
      paymentMethod: paymentMethod,
      itemsPrice: total,
      totalPrice: totalOrderCostPlusShipping,
      customerName: userName,
      client_id: userId,
      orderSrc: orderSource,
      idempotencyKey: idempotencyKeyRef.current,
      ...(buyer ? { buyer } : {}),
    };
  };

  const payMoMoCheckoutHandler = async (e) => {
    e.preventDefault();
    // MARKET RAIL SWITCH (multi_national): on markets where "MOMO" rides the
    // Flutterwave rail (Zambia — MTN ZM has no direct-MoMo integration), the
    // charge goes through the FW mobile-money flow with the registry network.
    // Uganda keeps the direct MTN rail below, byte-for-byte.
    if (isFwMomoMethod("MOMO")) {
      return payAirtelMoneyCheckoutHandler(e, fwNetworkFor("MOMO"));
    }
    // Never charge before the server fee is known (Contract §C1) — otherwise
    // the customer is charged items-only and the shipping fee is lost revenue.
    if (!deliveryFeeReady || freightConsentRequired) return;

    // WHY save but not send: no MoMo charge payload in this codebase carries an
    // email, so we only persist it to the profile — that is where the order
    // confirmation is addressed from. Best-effort; it must never block the pay.
    const typedEmail = emailInput.trim();
    if (!userEmail && typedEmail) {
      apiSetContactEmail(typedEmail).catch(() => {});
    }

    // Create the order FIRST and await it (Contract §B3). Previously payment
    // and createOrder fired concurrently, so a customer could be charged with
    // no order — or the payment bound to their "latest" unrelated order.
    const orderAction = await deliveryTime.submitOrder(createOrder, buildCreateOrderPayload());
    if (orderAction.error || orderAction.meta?.requestStatus !== "fulfilled") {
      return; // thunk already surfaced the backend message; do NOT charge
    }
    const orderId = extractCreatedOrderId(orderAction);

    dispatch(
      payMoMoCheckout({
        mobile: postData.mobile,
        totalPrice: totalOrderCostPlusShipping,
        client_id: userId,
        orderItems: products,
        // Bind the payment to the order we just created (Contract §B3),
        // instead of the backend's legacy latest-order fallback.
        orderId,
      })
    );
  };

  // Airtel Money Pay
  const generateTxRef = (clientId) => {
    return clientId + "-" + Date.now();
  };
  const payAirtelMoneyCheckoutHandler = async (e, networkOverride) => {
    e.preventDefault();
    if (!deliveryFeeReady || freightConsentRequired) return; // Contract §C1 — no charge without a server fee

    // Create + await the order before charging (see payMoMoCheckoutHandler).
    const orderAction = await deliveryTime.submitOrder(createOrder, buildCreateOrderPayload());
    if (orderAction.error || orderAction.meta?.requestStatus !== "fulfilled") {
      return;
    }
    const orderId = extractCreatedOrderId(orderAction);
    // Embed the order id in tx_ref as `${clientId}-${orderId}` so the
    // Flutterwave webhook can bind payment to THIS order (Contract §B3).
    const uniqueTxRef = orderId ? `${userId}-${orderId}` : generateTxRef(userId);

    // Use whatever they typed for THIS charge and save it to the profile too.
    // Best-effort: a failed save must never stop the payment.
    const typed = emailInput.trim();
    const effectiveEmail = userEmail || typed || undefined;
    if (!userEmail && typed) {
      apiSetContactEmail(typed).catch(() => {});
    }

    dispatch(
      payAirtelMoneyCheckout({
        mobile: postData.mobile,
        totalPrice: totalOrderCostPlusShipping,
        client_id: userId,
        email: effectiveEmail,
        uniqueTxRef: uniqueTxRef,
        // FW network for this market's method (MTN/AIRTEL/ZAMTEL). The legacy
        // fallback (the method key itself) keeps old UG behaviour if the
        // registry has no entry.
        network: networkOverride || fwNetworkFor(paymentMethod) || paymentMethod,
        redirect_url: `${window.location.origin}/airtelPay`,
        orderId,
      })
    ).then((action) => {
      if (!action.error && action.payload?.data?.meta?.authorization) {
        followCardRedirect(action.payload.redirectUrl);
      } else if (!action.error) {
        // The order already EXISTS: createOrder ran and was awaited above, so
        // silence here leaves the customer holding an unpaid order with no next
        // step and no idea anything went wrong. A REJECTED thunk has already
        // toasted the backend's own reason, so re-toasting it would just double
        // up; a 200 whose body carries no `meta.authorization` had no branch at
        // all, and that is the case this else was missing.
        toast.error(
          "We couldn't start the Airtel Money payment. Your order was created but has NOT been paid \u2014 open it in My Orders to try again.",
          { autoClose: false }
        );
      }
    });
  };

  const cardPlaceOrderHandler = async () => {
    if (!deliveryFeeReady || freightConsentRequired) return; // Contract §C1 — no charge without a server fee
    const cardDetails = {
      // cardNumber: cardFormData.cardNumber,
      cardNumber: formik.values.cardNumber,
      expiry_month: formik.values.expiry_month,
      expiry_year: formik.values.expiry_year,
      cardCvv: formik.values.cardCvv,
      cardType: formik.values.cardType,
      fullName: formik.values.fullName,
    };

    // Create + await the order before charging (see payMoMoCheckoutHandler).
    const orderAction = await deliveryTime.submitOrder(createOrder, buildCreateOrderPayload());
    if (orderAction.error || orderAction.meta?.requestStatus !== "fulfilled") {
      return;
    }
    const orderId = extractCreatedOrderId(orderAction);

    // Same optional-email treatment as Airtel (see payAirtelMoneyCheckoutHandler).
    const typed = emailInput.trim();
    const effectiveEmail = userEmail || typed || undefined;
    if (!userEmail && typed) {
      apiSetContactEmail(typed).catch(() => {});
    }

    dispatch(
      payCardCheckout({
        cardDetails,
        totalPrice: totalOrderCostPlusShipping,
        client_id: userId,
        customer_name: userName,
        email: effectiveEmail,
        network: paymentMethod,
        // redirect_url: `${window.location.origin}/pay/authorize`,
        redirect_url: `${window.location.origin}/cardOrder`,
        // Bind the card charge to THIS order: the backend builds
        // tx_ref = `${client_id}-${orderId}-${ts}` from body.orderId.
        orderId,
      })
    )
      .then((action) => {
        // console.log(action, "action>>>");
        // console.log(action.meta.arg.redirect_url, "action>>>");
        if (action.payload.redirectUrl) {
          // console.log(action, "action2>>>");
          followCardRedirect(action.payload.redirectUrl);
        }
      })
      .catch((err) => {
        console.error("Error while dispatching payCardCheckout:", err);
      });
  };

  // Rendered in each payment pane below. Deliberately not `required`, not
  // validated, and absent from every disabled= expression: ask, never block.
  const optionalEmailField = needsEmail ? (
    <EmailFieldWrap>
      <EmailLabel>
        Email <OptionalTag>optional</OptionalTag>
      </EmailLabel>
      <EmailInput
        value={emailInput}
        onChange={(e) => setEmailInput(e.target.value)}
        placeholder="you@example.com"
        inputMode="email"
        autoComplete="email"
        type="email"
      />
      <EmailHint>Add an email and we'll send your receipt there.</EmailHint>
    </EmailFieldWrap>
  ) : null;

  const capturedBuyer = buildBuyerPayload({
    type: buyerType,
    idType: buyerIdType,
    idNumber: buyerIdNumber,
    name: buyerName,
  });
  const buyerSummary = formatBuyerSummary(capturedBuyer);
  const buyerTaxIdField = (
    <BuyerWrap>
      {buyerOpen ? (
        <BuyerPanel>
          <EmailLabel>
            Buyer tax ID <OptionalTag>optional</OptionalTag>
          </EmailLabel>
          <BuyerRow>
            <BuyerSelect
              value={buyerType}
              onChange={(e) => setBuyerType(e.target.value)}
              aria-label="Buyer type"
            >
              {BUYER_TYPE_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </BuyerSelect>
            <BuyerSelect
              value={buyerIdType}
              onChange={(e) => setBuyerIdType(e.target.value)}
              aria-label="Tax id type"
            >
              {BUYER_ID_TYPE_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </BuyerSelect>
          </BuyerRow>
          <EmailInput
            value={buyerIdNumber}
            onChange={(e) => setBuyerIdNumber(e.target.value)}
            placeholder="Tax id number"
            type="text"
          />
          <EmailInput
            value={buyerName}
            onChange={(e) => setBuyerName(e.target.value)}
            placeholder="Business or buyer name"
            type="text"
            style={{ marginTop: "10px" }}
          />
          <EmailHint>{buyerIdHint(buyerIdType)}</EmailHint>
          {buyerSummary && <BuyerSummary>{buyerSummary}</BuyerSummary>}
        </BuyerPanel>
      ) : (
        <BuyerToggle type="button" onClick={() => setBuyerOpen(true)}>
          Buying for a business? Add a tax ID
        </BuyerToggle>
      )}
    </BuyerWrap>
  );

  // Show specific button text based on redux state
  let airtelButtonText;
  switch (true) {
    case paymentCreationStatus === "processing payment":
      airtelButtonText = "Processing Payment...";
      break;
    case paymentCreationStatus === "fulfilled":
      airtelButtonText = "Payment Initiated!";
      break;
    case paymentCreationStatus === "rejected":
      airtelButtonText = "Payment attempt Failed, try again!";
      break;
    case orderCreationStatus === "pending":
      airtelButtonText = "Creating Order...";
      break;
    case orderCreationStatus === "fulfilled":
      airtelButtonText = "Order Created...";
      break;
    default:
      airtelButtonText = "Proceed to Pay";
  }

  return (
    <>
      <Navbar />

      <Container
        maxWidth="100%"
        // maxWidth="lg"
        style={{ marginTop: "30px" }}
      >
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            <FreightCheckoutNotice />
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Typography
                  className={classes.responsiveFont}
                  // className="responsive-font"
                  sx={{ fontSize: 18, fontStyle: "italic" }}
                  gutterBottom
                >
                  SHIPPING ADDRESS
                </Typography>
              </Grid>

              <Grid item>
                <Typography
                  variant="body"
                  sx={{ fontSize: 13 }}
                  color="text.secondary"
                >
                  <b>Address:</b>{" "}
                  <span
                    style={{
                      fontStyle: "italic",
                      fontSize: "12px",
                      color: "#00668bc4",
                    }}
                  >
                    {shippingAddress.locationName &&
                    Object.keys(shippingAddress.locationName).length !== 0
                      ? shippingAddress.locationName.name
                      : "Not available"}
                  </span>
                </Typography>
              </Grid>

              <Grid item>
                <Typography
                  variant="body"
                  sx={{ fontSize: 13 }}
                  color="text.secondary"
                >
                  <b>Customer Contact:</b>{" "}
                  <span
                    style={{
                      fontStyle: "italic",
                      fontSize: "12px",
                      color: "#00668bc4",
                    }}
                  >
                    {shippingAddress.customerNumber &&
                    Object.keys(shippingAddress.customerNumber).length !== 0
                      ? shippingAddress.customerNumber
                      : "Not available"}
                  </span>
                </Typography>
              </Grid>

              <Grid item>
                <Typography
                  variant="body"
                  sx={{ fontSize: 15 }}
                  color="text.secondary"
                >
                  <b>Delivery Zone:</b>{" "}
                  <span
                    style={{
                      fontStyle: "italic",
                      fontSize: "12px",
                      color: "#00668bc4",
                    }}
                  >
                    {shippingAddress.locationName &&
                    Object.keys(shippingAddress.locationName).length !== 0
                      ? shippingAddress.locationName.vicinity
                      : "Not available"}
                  </span>
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="body"
                  sx={{ fontSize: 13 }}
                  color="text.secondary"
                >
                  <b>Payment Method:</b>{" "}
                  <span
                    style={{
                      fontStyle: "italic",
                      fontSize: "12px",
                      color: "#b63700",
                    }}
                  >
                    {paymentMethod && Object.keys(paymentMethod).length !== 0
                      ? paymentMethod
                      : "Not available"}
                  </span>
                </Typography>
              </Grid>
            </Grid>

            {buyerTaxIdField}

            <Divider style={{ paddingTop: "20px", marginBottom: "15px" }} />

            {/* Order Items Summary */}
            <Typography
              component="h2"
              variant="h6"
              color="primary"
              gutterBottom
            >
              ORDER ITEMS SUMMARY
            </Typography>
            <div className={classes.responsiveTable}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeader}>
                      PRODUCT IMAGE
                    </TableCell>
                    <TableCell className={classes.tableHeader}>NAME</TableCell>
                    <TableCell className={classes.tableHeaderCenter}>
                      PRICE
                    </TableCell>
                    <TableCell className={classes.tableHeaderCenter}>
                      QUANTITY
                    </TableCell>
                    <TableCell className={classes.tableHeaderCenter}>
                      SUM
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {products.map((item) => (
                    <TableRow key={item?._id} hover={true}>
                      <TableCell>
                        <Image
                          //  className="responsive-image"
                          className={classes.responsiveImage}
                          style={{
                            width: "100px",
                            height: "90px",
                            borderRadius: "10%",
                          }}
                          src={item.imageUrl}
                          alt={item.imageUrl}
                          fluid
                          rounded
                        />
                      </TableCell>

                      <TableCell
                        variant="body"
                        sx={{ fontSize: 15 }}
                        color="text.secondary"
                      >
                        {item?.name}
                      </TableCell>
                      <TableCell
                        variant="body"
                        sx={{ fontSize: 15, textAlign: "center" }}
                        color="text.secondary"
                      >
                        {item?.price}
                      </TableCell>
                      <TableCell
                        variant="body"
                        sx={{ fontSize: 15, textAlign: "center" }}
                        color="text.secondary"
                      >
                        {item?.qty}
                      </TableCell>
                      <TableCell
                        variant="body"
                        sx={{ fontSize: 15, textAlign: "center" }}
                        color="text.secondary"
                      >
                        {(item?.qty * item?.price)
                          ?.toString()
                          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <DeliveryTimePicker controller={deliveryTime} />

              {/* Place order */}
              <Card
                sx={{ minWidth: 275 }}
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                {paymentMethod === "COD" && (
                  <CardContent>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{ fontSize: 24, fontStyle: "italic" }}
                            colSpan={2}
                          >
                            Order Cost Summary
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell
                            variant="body"
                            sx={{ fontSize: 15 }}
                            color="text.secondary"
                          >
                            Shipping Cost:
                          </TableCell>

                          <TableCell
                            variant="body"
                            sx={{ fontSize: 15, color: "#004b67" }}
                          >
                            <DeliveryFeeStatus
                              {...feeStatusProps}
                              freightQuotedSeparately={quoteFulfillment?.required === true}
                              value={formatCurrency(serverShippingFee || 0)}
                            />
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            variant="body"
                            sx={{ fontSize: 15 }}
                            color="text.secondary"
                          >
                            <b>Total:</b>
                          </TableCell>

                          <TableCell
                            variant="body"
                            sx={{ fontSize: 15, color: "#004b67" }}
                          >
                            <DeliveryFeeStatus
                              {...feeStatusProps}
                              value={formatCurrency(totalOrderCostPlusShipping)}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>

                    <Divider
                      style={{ paddingTop: "10px", marginBottom: "10px" }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={placeOrderHandler}
                      disabled={
                        !deliveryFeeReady ||
                        freightConsentRequired ||
                        belowMinimumOrder
                      }
                      style={{
                        width: "100%",
                      }}
                    >
                      Place Order
                    </Button>
                  </CardContent>
                )}

                {/* Visa */}
                {paymentMethod === "Visa" && (
                  <CardContent
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between", // Add space around items
                    }}
                  >
                    {/* Part on the extreme left where the SVG of the selected card will be shown */}

                    <div
                      style={{
                        flexGrow: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "300px",
                        height: "300px",
                        // marginBottom: "40px",
                      }}
                    ></div>
                    {/* Middle part: Order Cost Summary Visa table */}
                    <div style={{ flexGrow: 1 }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{ fontSize: 24, fontStyle: "italic" }}
                              colSpan={2}
                            >
                              Order Cost Summary Visa
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              variant="body"
                              sx={{
                                fontSize: 15,
                                width: "20%",
                                color: "text.secondary",
                              }}
                            >
                              <b>Shipping Cost:</b>
                            </TableCell>

                            <TableCell
                              variant="body"
                              sx={{ fontSize: 15, color: "#004b67" }}
                            >
                              <DeliveryFeeStatus
                                {...feeStatusProps}
                                freightQuotedSeparately={quoteFulfillment?.required === true}
                                value={formatCurrency(serverShippingFee || 0)}
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell
                              variant="body"
                              sx={{
                                fontSize: 15,
                                width: "20%",
                                color: "text.secondary",
                              }}
                            >
                              <b>Total:</b>
                            </TableCell>

                            <TableCell
                              variant="body"
                              sx={{ fontSize: 15, color: "#004b67" }}
                            >
                              <DeliveryFeeStatus
                                {...feeStatusProps}
                                value={formatCurrency(totalOrderCostPlusShipping)}
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </div>

                    {/* Part on the right: card input fields */}
                    <div
                      className={classes.responsiveCard}
                      // style={{ flexGrow: 1 }}
                    >
                      <CreditCardForm
                        // onFormChange={handleFormChange}
                        onFormChange={(data) => {
                          let expiry_month, expiry_year;
                          if (typeof data.expirationDate === "string") {
                            [expiry_month, expiry_year] =
                              data.expirationDate.split("/");
                          } else {
                            expiry_month = null;
                            expiry_year = null;
                          }

                          formik.setValues({
                            cardNumber: data.cardNumber,
                            expiry_month: expiry_month,
                            expiry_year: expiry_year,
                            cardCvv: data.cvv,
                            cardType: data.cardType,
                            fullName: data.fullName,
                          });
                          // setCardFormData(data);
                        }}
                        values={formik.values}
                        errors={formik.errors}
                        touched={formik.touched}
                        handleBlur={formik.handleBlur}
                        handleChange={formik.handleChange}
                      />
                      <Divider
                        style={{ paddingTop: "10px", marginBottom: "10px" }}
                      />
                      {optionalEmailField}
                      <PayCardButton
                        variant="contained"
                        color="primary"
                        // onClick={cardPlaceOrderHandler}
                        // onClick={handleSubmit}
                        onClick={formik.submitForm}
                        disabled={
                          paymentCreationStatus === "pending" ||
                          orderCreationStatus === "pending" ||
                          !deliveryFeeReady ||
                          freightConsentRequired ||
                          belowMinimumOrder ||
                          !formik.isValid
                          // !formik.dirty
                        }
                        style={{
                          width: "100%",
                        }}
                      >
                        {paymentCreationStatus === "pending" ||
                        orderCreationStatus === "pending"
                          ? "Processing..."
                          : "Pay"}
                      </PayCardButton>
                    </div>

                    <Divider
                      style={{ paddingTop: "10px", marginBottom: "10px" }}
                    />
                  </CardContent>
                )}

                {/* MTN Mobile Money */}
                {paymentMethod === "MOMO" && (
                  <CardContent
                    style={{
                      flex: "3",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{ fontSize: 24, fontStyle: "italic" }}
                            colSpan={2}
                          >
                            Order Cost Summary
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell
                            variant="body"
                            sx={{
                              fontSize: 15,
                              width: "20%",
                              color: "text.secondary",
                            }} // adjust the width as per your requirement
                          >
                            <b>Shipping Cost:</b>
                          </TableCell>

                          <TableCell
                            variant="body"
                            sx={{ fontSize: 15, color: "#004b67" }}
                          >
                            <DeliveryFeeStatus
                              {...feeStatusProps}
                              freightQuotedSeparately={quoteFulfillment?.required === true}
                              value={formatCurrency(serverShippingFee || 0)}
                            />
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            variant="body"
                            sx={{
                              fontSize: 15,
                              width: "20%",
                              color: "text.secondary",
                            }} // adjust the width as per your requirement
                          >
                            <b>Total:</b>
                          </TableCell>

                          <TableCell
                            variant="body"
                            sx={{ fontSize: 15, color: "#004b67" }}
                          >
                            <DeliveryFeeStatus
                              {...feeStatusProps}
                              value={formatCurrency(totalOrderCostPlusShipping)}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>

                    <div style={{ paddingBottom: "20px", paddingTop: "10px" }}>
                      <Box
                        sx={{
                          // bgcolor: "background.paper",
                          bgcolor: theme.palette.background.paper,
                          boxShadow: "0px 3px 5px 2px rgba(0, 0, 0, .3)",
                          p: 1, // padding
                          borderRadius: 2,
                          width: { xs: "100%", sm: "100%", md: "28%" },
                          margin: "0px 0px 4px 0px",
                        }}
                      >
                        <TextField
                          className={`${classes.input} ${
                            postData?.mobile?.length === 10
                              ? classes.inputGreen
                              : ""
                          }`}
                          id="outlined-basic"
                          label="Enter MTN Number"
                          variant="outlined"
                          type="number"
                          color="secondary"
                          value={postData?.mobile}
                          //No character entry allowed after 10 digits
                          onChange={(e) => {
                            if (e.target.value.length <= 10) {
                              setPostData({
                                ...postData,
                                mobile: e.target.value,
                              });
                            }
                          }}
                          //Maximum allowed digits = 10
                          inputProps={{
                            maxLength: 10,
                          }}
                          // Prevent Keyboard arrow keys from de/incrementing
                          onKeyDown={(e) => {
                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                              e.preventDefault();
                            }
                          }}
                          fullWidth
                          name="mobile"
                          placeholder="Enter your MTN Number..."
                          required
                        />
                      </Box>
                    </div>

                    {optionalEmailField}

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={payMoMoCheckoutHandler}
                      disabled={
                        postData.mobile.length < 10 ||
                        !deliveryFeeReady ||
                        freightConsentRequired ||
                        belowMinimumOrder ||
                        orderCreationStatus === "pending" ||
                        paymentCreationStatus === "pending" ||
                        orderCreationStatus === "fulfilled"
                      }
                      // Cursor is disabled if the length of the input is less than 10
                      className="Button"
                    >
                      <img
                        style={{
                          width: 65,
                          height: 50,
                          borderRadius: 5,
                          alignSelf: "left",
                          paddingRight: "10px",
                        }}
                        src={momo}
                        // src={require("assets/img/momo.jpg").default}
                        alt="mtn-logo"
                      />
                      Proceed to Pay
                    </Button>
                  </CardContent>
                )}
                {/* Airtel Money / Zamtel Kwacha (both charge over the FW rail) */}
                {(paymentMethod === "Airtel" || paymentMethod === "ZAMTEL") && (
                  <CardContent
                    style={{
                      flex: "3",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{ fontSize: 24, fontStyle: "italic" }}
                            colSpan={2}
                          >
                            Order Cost Summary
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell
                            variant="body"
                            sx={{
                              fontSize: 15,
                              width: "20%",
                              color: "text.secondary",
                            }} // adjust the width as per your requirement
                          >
                            <b>Shipping Cost:</b>
                          </TableCell>

                          <TableCell
                            variant="body"
                            sx={{ fontSize: 15, color: "#004b67" }}
                          >
                            <DeliveryFeeStatus
                              {...feeStatusProps}
                              freightQuotedSeparately={quoteFulfillment?.required === true}
                              value={formatCurrency(serverShippingFee || 0)}
                            />
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            variant="body"
                            sx={{
                              fontSize: 15,
                              width: "20%",
                              color: "text.secondary",
                            }} // adjust the width as per your requirement
                          >
                            <b>Total:</b>
                          </TableCell>

                          <TableCell
                            variant="body"
                            sx={{ fontSize: 15, color: "#004b67" }}
                          >
                            <DeliveryFeeStatus
                              {...feeStatusProps}
                              value={formatCurrency(totalOrderCostPlusShipping)}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>

                    <div style={{ paddingBottom: "20px", paddingTop: "10px" }}>
                      <Box
                        sx={{
                          // bgcolor: "background.paper",
                          bgcolor: theme.palette.background.paper,
                          boxShadow: "0px 3px 5px 2px rgba(0, 0, 0, .3)",
                          p: 1, // padding
                          borderRadius: 2,
                          width: { xs: "100%", sm: "100%", md: "28%" },
                          margin: "0px 0px 4px 0px",
                        }}
                      >
                        <TextField
                          className={`${classes.input} ${
                            postData?.mobile?.length === 10
                              ? classes.inputGreen
                              : ""
                          }`}
                          id="outlined-basic"
                          label="Enter Airtel Number"
                          variant="outlined"
                          type="number"
                          color="secondary"
                          value={postData?.mobile}
                          //No character entry allowed after 10 digits
                          onChange={(e) => {
                            if (e.target.value.length <= 10) {
                              setPostData({
                                ...postData,
                                mobile: e.target.value,
                              });
                            }
                          }}
                          // Maximum allowed digits = 10
                          inputProps={{
                            maxLength: 10,
                          }}
                          // Prevent Keyboard arrow keys from de/incrementing
                          onKeyDown={(e) => {
                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                              e.preventDefault();
                            }
                          }}
                          fullWidth
                          name="mobile"
                          placeholder="Enter your Airtel Number..."
                          required
                        />
                      </Box>
                    </div>

                    {optionalEmailField}

                    <AirtelPayButton
                      variant="contained"
                      color="primary"
                      onClick={payAirtelMoneyCheckoutHandler}
                      disabled={
                        postData.mobile.length < 10 ||
                        !deliveryFeeReady ||
                        freightConsentRequired ||
                        belowMinimumOrder ||
                        orderCreationStatus === "pending" ||
                        paymentCreationStatus === "pending" ||
                        paymentCreationStatus === "processing payment" ||
                        paymentCreationStatus === "fulfilled" ||
                        orderCreationStatus === "fulfilled"
                      }
                      // Cursor is disabled if the length of the input is less than 10
                      // className="Button"
                    >
                      {paymentMethod === "Airtel" && (
                        <img
                          style={{
                            width: 65,
                            height: 55,
                            borderRadius: 5,
                            alignSelf: "left",
                            boxShadow: "0px 0px 10px rgba(255, 255, 255, 0.9)",
                          }}
                          src={airtel}
                          alt="airtel-logo"
                        />
                      )}
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "white",
                          paddingLeft: "11px",
                        }}
                      >
                        {airtelButtonText}
                      </span>
                    </AirtelPayButton>
                  </CardContent>
                )}
              </Card>
            </div>
          </CardContent>
        </Card>
      </Container>
    </>
  );
};

export default PlaceOrderScreen;
